class ScrollToTopButton extends HTMLElement {
  constructor() {
    super();
    
    this.button = this.querySelector('.scroll-to-top-button__btn');
    this.scrollOffset = parseInt(this.dataset.scrollOffset) || 300;
    this.isVisible = false;
    
    this.handleScroll = this.handleScroll.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
    
    if (this.button) {
      this.button.addEventListener('click', this.scrollToTop);
    }
    
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.handleScroll(); // Check initial state
  }
  
  connectedCallback() {
    if (Shopify && Shopify.designMode) {
      this.onShopifySectionLoad = this.onSectionLoad.bind(this);
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
      document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }
  
  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    if (Shopify && Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }
  
  onSectionLoad(event) {
    if (event.detail.sectionId === this.dataset.sectionId) {
      this.handleScroll();
    }
  }
  
  onSectionSelect(event) {
    if (event.detail.sectionId === this.dataset.sectionId) {
      this.classList.add('is-selected');
    }
  }
  
  onSectionDeselect(event) {
    if (event.detail.sectionId === this.dataset.sectionId) {
      this.classList.remove('is-selected');
    }
  }
  
  handleScroll() {
    if (Shopify && Shopify.designMode) {
      return;
    }
    
    const scrollY = window.scrollY || window.pageYOffset;
    const shouldBeVisible = scrollY > this.scrollOffset;
    
    if (shouldBeVisible !== this.isVisible) {
      this.isVisible = shouldBeVisible;
      if (this.isVisible) {
        this.classList.add('is-visible');
      } else {
        this.classList.remove('is-visible');
      }
    }
  }
  
  scrollToTop(event) {
    event.preventDefault();
    
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

customElements.define('scroll-to-top-button', ScrollToTopButton);
